<template><div><h1>v-transfer-dom 指令</h1>
<p>在移动端应用里，为了便于代码组织，通常我们要将组件放在各个路由的 <code>.vue</code> 文件里，但是因为此时组件并不在 <code>body</code> 下，加上定位，overflowscrolling 设置等原因，会出现遮罩在弹层之上，z-index 失效等问题。</p>
<p>因此我们推荐在纯弹窗类组件比如 <code>Alert</code> <code>Popup</code> <code>XDialog</code> 等组件上使用 <code>v-transfer-dom</code> 实现自动移动到 body 下，解决以上问题。</p>
<div class="warning">
<p>必须有一个 <code>div</code> 作为占位元素否则会出错</p>
</div>
<h2>使用</h2>
<h3>注册局部指令</h3>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { TransferDom } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">directives</span>: {
    TransferDom
  }
}
</code></pre>
<h3>注册全局指令</h3>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { TransferDom } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

Vue.directive(<span class="hljs-string">'transfer-dom'</span>, TransferDom)
</code></pre>
<h3>模板使用</h3>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">popup</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">popup</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
</code></pre>
</div></template><script>
export default {
  head: {"title":"v-transfer-dom 指令 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v-transfer-dom-296.vue?3e1f355b